import React from 'react';
interface HomeTabProps {
  setActiveTab: (tab: string) => void;
}
export function HomeTab({
  setActiveTab
}: HomeTabProps) {
  const cards = [{
    id: 'systems',
    icon: '🔄',
    title: 'Six Systems',
    description: 'Explore the six meridian balancing systems: Name-Sharing, Bie-Jing, Biao-Li, Clock Opposites, Clock Neighbors, and Self-Balance.'
  }, {
    id: 'protocols',
    icon: '💊',
    title: 'Treatment Protocols',
    description: 'Million Dollar Combos and proven point combinations for back pain, headaches, fibromyalgia, shoulder pain, and more.'
  }, {
    id: 'patterns',
    icon: '📋',
    title: 'Pattern Protocols',
    description: 'Constitutional patterns: Jueyin-Shaoyang, Jueyin-Yangming, Shaoyin-Shaoyang, and Taiyin-Yangming with complete indications.'
  }, {
    id: 'mirroring',
    icon: '🪞',
    title: 'Mirroring & Imaging',
    description: 'Direct and reverse mirroring techniques, plus imaging correspondences for precise point selection.'
  }, {
    id: 'hologram',
    icon: '🌐',
    title: 'Hologram Theory',
    description: 'Body part to acupuncture point correspondences based on holographic microsystem theory.'
  }, {
    id: 'global',
    icon: '🌍',
    title: 'Global Balance',
    description: 'Front, side, and back body treatment patterns using four magical meridians in truss formations.'
  }, {
    id: 'seasonal',
    icon: '🍂',
    title: 'Seasonal Balance',
    description: 'Five Element seasonal point sequences to enhance treatment effectiveness based on timing.'
  }, {
    id: 'bagua',
    icon: '☯️',
    title: 'Ba Gua Conversion',
    description: 'Advanced Eight Trigrams system for meridian conversion and specialized treatment protocols.'
  }, {
    id: 'iching',
    icon: '📿',
    title: 'I-Ching System',
    description: 'Hexagram-based point selection using the Book of Changes for sophisticated treatment strategies.'
  }, {
    id: 'tung',
    icon: '⭐',
    title: "Master Tung's Points",
    description: 'Comprehensive compilation with strongest acting points marked, reaction areas, and complete clinical applications.'
  }];
  return <div data-id="element-319">
      <div className="bg-white p-8 rounded-2xl shadow-lg mb-8" data-id="element-320">
        <h2 className="text-3xl font-bold text-teal-700 mb-4" data-id="element-321">
          Welcome to the Balance Method Reference
        </h2>
        <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-322">
          The Balance Method, developed by Dr. Richard Tan, is a revolutionary
          acupuncture system based on the principle of treating distal points to
          affect areas of pain or dysfunction. By needling meridians away from
          the affected area, we can achieve immediate and dramatic results.
        </p>
        <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-323">
          <strong className="text-teal-700" data-id="element-324">Core Principle:</strong> Pain or
          disease in one meridian can be balanced by needling points on related
          meridians, typically on the opposite limb.
        </p>
        <p className="text-gray-700 leading-relaxed" data-id="element-325">
          This comprehensive reference guide provides instant access to all six
          systems, treatment protocols, Master Tung's extraordinary points, and
          clinical strategies.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-326">
        {cards.map(card => <div key={card.id} onClick={() => setActiveTab(card.id)} className="bg-white p-6 rounded-xl shadow-lg cursor-pointer transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 border border-gray-200" data-id="element-327">
            <div className="text-4xl mb-4" data-id="element-328">{card.icon}</div>
            <h3 className="text-xl font-bold text-teal-700 mb-3" data-id="element-329">
              {card.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-330">
              {card.description}
            </p>
          </div>)}
      </div>
    </div>;
}